export const MAX_ERROR_ROWS = 5
export const MAX_DUPLICATE_ROWS = 5
export const MAX_PREVIEW_ROWS = 10
